import { wrapContained as withStyle } from 'utils/styles'

export default withStyle(
  (props) => `
    width:100%;
    .ant-select{
      width:100%
    }
  `
)
